// extracted by mini-css-extract-plugin
export default {"categorias":"Inicio_categorias__RIk-I"};